<template>
  <div>
    <div class="header">
      <div class="header-flex">
        <h1 class="title">Herberg van het Hart</h1>
        <MainMenu v-bind:page="page"></MainMenu>
      </div>
    </div>
    <div class="header-shadow"></div>
  </div>
</template>

<script>
import MainMenu from "./MainMenu";

export default {
  name: "header",
  data() {
    return {};
  },
  computed: {},
  methods: {},
  components: {
    MainMenu
  },
  props: ["page"]
};
</script>

<style lang="less">
@import "../styles/styles.less";

.title {
  color: @light-blue-1;
  text-align: left;
  margin-bottom: 0;
}
.header {
  height: 125px;
  min-width: @container-width;
  background-image: linear-gradient(@header-light, @header-dark);
  box-shadow: @shadow-down;
  margin-bottom: 6px;
}

.header-flex {
  height: 125px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/MainHeader.vue